"use strict";
require.context("../../images", true);
function coalitionMenuClickToOpen() {
  document.querySelectorAll(
    ".menu-bar__breadcrumb-desktop__dropdown-wrapper[onmouseenter], .menu-bar__breadcrumb-desktop__dropdown-wrapper [onmouseenter]"
  ).forEach((el) => el.removeAttribute("onmouseenter"));
  document.querySelectorAll('.menu-bar [data-controller~="dropdown"][data-hover="true"]').forEach((trigger) => {
    trigger.removeAttribute("data-hover");
    trigger.replaceWith(trigger.cloneNode(true));
  });
}
if (document.readyState !== "loading") {
  coalitionMenuClickToOpen();
}
["DOMContentLoaded", "turbo:load", "turbo:render"].forEach(
  (evt) => document.addEventListener(evt, coalitionMenuClickToOpen)
);
